import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Auth/AuthReducer";
import statsReducer from "./Stats/StatsReducer";
import uploadReducer from "./Upload/UploadReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    stats: statsReducer,
    upload: uploadReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
